import React from 'react';
import ModalLayoutPrimary
   from '../../../../components/ui/modals/Modal/components/ModalLayoutPrimary/ModalLayoutPrimary';
import FieldCheckbox from '../../../../components/ui/forms/fields/FieldCheckbox/FieldCheckbox';
import Modal from '../../../../components/ui/modals/Modal/Modal';
import styles from './OrderConfirmOfferModal.module.scss';
import AppText from '../../../../components/ui/typography/AppText/AppText';
import ModalFooterWithButtons from '../../../../components/ui/modals/components/ModalFooterWithButtons';
import { useAppSelector } from '../../../../hooks/reduxHooks';
import { Trans } from 'react-i18next';
import { useAppTranslate } from '../../../../hooks/useAppTranslate';
import SenseBandInfoData from './SenseBankInfoData';

type Props = {
   onClose: () => void;
   onConfirm?: () => Promise<void> | void;
   isConfirming?: boolean;
}

const OrderConfirmOfferModal: React.FC<Props> = ({ onClose, onConfirm, isConfirming = false }) => {
   const [checked, setChecked] = React.useState(false);
   const { paymentServerData } = useAppSelector(state => state.order);
   const { t } = useAppTranslate();

   return (
      <Modal onClose={onClose}>
         <ModalLayoutPrimary
            title={'Підтвердження бронювання'}
            style={{maxWidth: 800}}
            Footer={() => (
               <ModalFooterWithButtons
                  cancelButtonLabel={'Скасувати'}
                  actionButtonLabel={'Продовжити'}
                  onActionButtonClick={onConfirm}
                  actionButtonDisabled={!checked || isConfirming}
                  actionButtonLoading={isConfirming}
                  onCancel={onClose}
                  cancelButtonDisabled={isConfirming}
               />
            )}
         >
            <div className={styles.container}>
               <p className={styles.infoText}>
                  <AppText variant={'B500'}>
                     {t('Вас буде перенаправлено на сторінку безпечного платіжного сервісу для завершення оплати')}
                  </AppText>
               </p>

               <div className={styles.checkboxContainer}>
                  <label htmlFor={'offerCheckbox'}>
                     <FieldCheckbox checked={checked} onChange={() => setChecked(!checked)} className={styles.input}
                                    id={'offerCheckbox'} />
                     <AppText variant={'caption'} className={styles.checkboxText}>
                        <Trans i18nKey="orderOfferConfirmCheckboxText">
                           Я погоджуюсь з умовами <a href={paymentServerData?.redirect?.publicOffer || ''}
                                                     target={'_blank'}>договору</a> оферти.
                        </Trans>
                     </AppText>
                  </label>
               </div>

               <SenseBandInfoData />
            </div>
         </ModalLayoutPrimary>
      </Modal>
   );
};

export default OrderConfirmOfferModal;
